<template>
<div id="app" style="margin-top:0; margin-bottom: 60px;">
    <transition>
      <div id="e3" style="max-width:900px; margin:auto;" class="grey lighten-3">
        <v-card>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12>
                <v-img :src="svg1"></v-img>
              </v-flex>
              <!--v-flex xs12>
                <v-img :src="svg11"></v-img>
              </v-flex -->
              <!--v-flex xs12>
                <v-img :src="svg12"></v-img>
              </v-flex-->
              <v-flex xs12 md6>
                <v-img :src="svg11" min-width="400px"></v-img>
                <v-card flat tile class="d-flex justify-center">
                <v-img :src="svgPlan" min-width="400px" max-width="400px"></v-img>
                </v-card>
                <v-card flat tile class="d-flex justify-center">
                    <v-img min-width="400px" max-width="400px" min-height="400px" max-height="400px" 
                    :src="editedItem.url1" class="grey lighten-2" >
                    <template v-slot:placeholder>
                        <v-layout fill-height align-center justify-center ma-0>
                            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                        </v-layout>
                    </template>
                    </v-img>
                </v-card>
                <!--v-text-field v-model="editedItem.serial1" label="Serial1" readonly="true"></v-text-field-->
                </v-flex>

                <v-flex xs12 md6>
                  <v-img :src="svg12"  min-width="400px"></v-img>
                  <v-card flat tile class="d-flex justify-center">
                  <v-img :src="svgRouph" min-width="400px" max-width="400px"></v-img>
                  </v-card>
                  <v-card flat tile class="d-flex justify-center">
                      <v-img min-width="400px" max-width="400px" min-height="400px" max-height="400px" 
                      :src="editedItem.url2" class="grey lighten-2">
                      <template v-slot:placeholder>
                          <v-layout fill-height align-center justify-center ma-0>
                              <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                          </v-layout>
                      </template>
                      </v-img>
                  </v-card>
                <!--v-text-field v-model="editedItem.serial2" label="Serial2" readonly="true"></v-text-field-->
                </v-flex>

                <v-flex xs12>
                <v-img :src="svgLine"></v-img>
                </v-flex>
                <v-flex xs12 md6 justify-center>
                <label for="inserial1">TWINS DIAMOND Serial No.1 :</label>
                <input id="inserial1" v-model="editedItem.serial1" readonly style="width:100px;border-style:ridge">
                </v-flex>
                <v-flex xs12 md6 justify-center>
                <label for="inserial2">TWINS DIAMOND Serial No.2 :</label>
                <input id="inserial2" v-model="editedItem.serial2" readonly style="width:100px;border-style:ridge" >
                </v-flex>
                <v-flex xs12>
                <v-img :src="svgLine"></v-img>
                </v-flex>
                
                <v-flex xs12 justify-center>
                    <v-btn small @click="close">閉じる</v-btn>
                </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </div>
    <!--/v-app-->
     </transition>
 </div>
</template>

<script>
import MobileIs from 'ismobilejs';
import img1 from '@/assets/svg/ViewTitle.svg';
import img11 from '@/assets/svg/PhotoTitle1.svg';
import img12 from '@/assets/svg/PhotoTitle2.svg';
import imgplan from '@/assets/svg/PlanPhoto.svg';
import imgrouph from '@/assets/svg/RouphPhoto.svg';
import imgline from '@/assets/svg/line.svg';
import blank from '@/assets/blank.png';

export default {
    data: () => ({
        svg1:img1,
        svg11:img11,
        svg12:img12,
        svgPlan:imgplan,
        svgRouph:imgrouph,
        svgLine:imgline,
        txtSerial1:'',
        txtSerial2:'',
      catalog: [],
      editedItem: {
        serial1: '',
        serial2: '',
        file1:'',
        file2:'',
        url1:'',
        url2:'',
        memo: '',
        createdt:  new Date().toISOString().substr(0, 10)
      },
    }),
    created () {
        this.checkMobile();
        this.getItem();
    },
    computed:{
    },
    methods: {
      checkMobile(){
        if (MobileIs.phone){
            this.$router.push({ name: 'mview' });
        }
      },
      initialize () {},

      getItem(){ 
        if(!this.$store.state.viewparam.catalog){
          this.close();
        }
        if( this.$store.state.viewparam.catalog.serial1.length < 1){
          this.close();
        }       
        this.editedItem = this.$store.state.viewparam.catalog;
        if (!this.editedItem.file1) {
            this.editedItem.file1 = 'blank.png';
            this.editedItem.url1 = blank;
        }
        if (!this.editedItem.file2) {
            this.editedItem.file2 = 'blank.png';
            this.editedItem.url2 = blank;
        }
      },
      
      close () {
        this.$router.push({ name: 'guest' });
      }
    }
}
</script>
<style>
.estyle{
  width:"80px";
}
#app {
  width:"500px";
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
</style>
